import React, { useEffect, useMemo, useState } from 'react';
import { Button, message, Modal, Tag, Tooltip } from 'antd';
import scss from 'components/top/AiDrawer/AiDrawer.scss';
import ThinkingIcon from 'svg/v2/newcs_aiassistant_deepthinking.svg';
import { AiOutlineLike, AiOutlineDislike, AiFillLike, AiFillDislike } from "react-icons/ai";
import { SlRefresh } from "react-icons/sl";
import { BsCopy } from "react-icons/bs";
import CsSimpleButton from 'components/antd-extension/CsSimpleButton';
import { ze } from 'utils/zhEn';

const AiChatButtons = ({
  showLikeButtons,
  isLikeSelected,
  isDislikeSelected,
  onCopy,
  onRefresh,
  onLike,
  onDislike,
}) => {
  const handleCopy = () => {
    if (onCopy) {
      onCopy();
    }
  };

  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    }
  };

  const handleLike = () => {
    if (onLike) {
      onLike();
    }
  };

  const handleDislike = () => {
    if (onDislike) {
      onDislike();
    }
  };

  return <div className={scss.chatButtons}>
    <Tooltip title={ze('复制内容', 'Copy Content')}>
      <CsSimpleButton
        onClick={handleCopy}
      ><BsCopy size={16} /></CsSimpleButton>
    </Tooltip>
    <Tooltip title={ze('重新生成', 'Regenerate')}>
      <CsSimpleButton
        onClick={handleRefresh}
      ><SlRefresh size={16} /></CsSimpleButton>
    </Tooltip>
    { showLikeButtons && <Tooltip title={ze('有帮助', 'Like')}>
      <CsSimpleButton
        onClick={handleLike}
      >{isLikeSelected ? <AiFillLike size={18} className={scss.highlighted} /> : <AiOutlineLike size={18} />}</CsSimpleButton>
    </Tooltip> }
    { showLikeButtons && <Tooltip title={ze('没有帮助', 'Dislike')}>
      <CsSimpleButton
        onClick={handleDislike}
      >{isDislikeSelected ? <AiFillDislike size={18} className={scss.highlighted} /> : <AiOutlineDislike size={18} />}</CsSimpleButton>
    </Tooltip> }
  </div>;
};

export default AiChatButtons;
